var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('div', {
    staticClass: "card card-custom gutter-b"
  }, [_c('div', {
    staticClass: "card-header card-header-tabs-line"
  }, [_c('ul', {
    ref: "builder-tab",
    staticClass: "nav nav-dark nav-bold nav-tabs nav-tabs-line",
    attrs: {
      "role": "tablist"
    }
  }, [_c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link active",
    attrs: {
      "data-tab": "0",
      "data-toggle": "tab",
      "href": "#",
      "role": "tab"
    },
    on: {
      "click": _vm.setActiveTab
    }
  }, [_vm._v(" Geral ")])]), _c('li', {
    staticClass: "nav-item"
  }, [_c('a', {
    staticClass: "nav-link",
    attrs: {
      "data-tab": "1",
      "data-toggle": "tab",
      "href": "#",
      "role": "tab"
    },
    on: {
      "click": _vm.setActiveTab
    }
  }, [_vm._v(" Alíquotas ")])])])]), _c('b-form', {
    staticClass: "form",
    on: {
      "submit": function submit($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('b-tabs', {
    staticClass: "hide-tabs",
    model: {
      value: _vm.tabIndex,
      callback: function callback($$v) {
        _vm.tabIndex = $$v;
      },
      expression: "tabIndex"
    }
  }, [_c('b-tab', {
    attrs: {
      "active": ""
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "4"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "descricao",
      "label-for": "descricao",
      "label": "Descrição",
      "placeholder": "Venda de mercadoria"
    }
  }, [_c('b-form-input', {
    attrs: {
      "state": _vm.validateState('descricao')
    },
    model: {
      value: _vm.$v.form.descricao.$model,
      callback: function callback($$v) {
        _vm.$set(_vm.$v.form.descricao, "$model", $$v);
      },
      expression: "$v.form.descricao.$model"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "base_icms",
      "label-for": "cofins",
      "label": "% Base ICMS"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    model: {
      value: _vm.form.base_icms,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "base_icms", $$v);
      },
      expression: "form.base_icms"
    }
  }, 'money', _vm.configMoney, false))], 1)], 1), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "base_icmsfe",
      "label-for": "cofins",
      "label": "% Base ICMS F.E"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    model: {
      value: _vm.form.base_icmsfe,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "base_icmsfe", $$v);
      },
      expression: "form.base_icmsfe"
    }
  }, 'money', _vm.configMoney, false))], 1)], 1), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "base_icmsst",
      "label-for": "cofins",
      "label": "% Base ICMS ST"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    model: {
      value: _vm.form.base_icmsst,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "base_icmsst", $$v);
      },
      expression: "form.base_icmsst"
    }
  }, 'money', _vm.configMoney, false))], 1)], 1), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "id": "diferimento",
      "label-for": "cofins",
      "label": "% Diferimento"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    model: {
      value: _vm.form.diferimento,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "diferimento", $$v);
      },
      expression: "form.diferimento"
    }
  }, 'money', _vm.configMoney, false))], 1)], 1)], 1)], 1), _c('b-tab', [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "AC"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    model: {
      value: _vm.form.aliquota.ac,
      callback: function callback($$v) {
        _vm.$set(_vm.form.aliquota, "ac", $$v);
      },
      expression: "form.aliquota.ac"
    }
  }, 'money', _vm.configMoney, false))], 1)], 1), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "AL"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    model: {
      value: _vm.form.aliquota.al,
      callback: function callback($$v) {
        _vm.$set(_vm.form.aliquota, "al", $$v);
      },
      expression: "form.aliquota.al"
    }
  }, 'money', _vm.configMoney, false))], 1)], 1), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "AM"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    model: {
      value: _vm.form.aliquota.am,
      callback: function callback($$v) {
        _vm.$set(_vm.form.aliquota, "am", $$v);
      },
      expression: "form.aliquota.am"
    }
  }, 'money', _vm.configMoney, false))], 1)], 1), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "AP"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    model: {
      value: _vm.form.aliquota.ap,
      callback: function callback($$v) {
        _vm.$set(_vm.form.aliquota, "ap", $$v);
      },
      expression: "form.aliquota.ap"
    }
  }, 'money', _vm.configMoney, false))], 1)], 1), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "BA"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    model: {
      value: _vm.form.aliquota.ba,
      callback: function callback($$v) {
        _vm.$set(_vm.form.aliquota, "ba", $$v);
      },
      expression: "form.aliquota.ba"
    }
  }, 'money', _vm.configMoney, false))], 1)], 1), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "CE"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    model: {
      value: _vm.form.aliquota.ce,
      callback: function callback($$v) {
        _vm.$set(_vm.form.aliquota, "ce", $$v);
      },
      expression: "form.aliquota.ce"
    }
  }, 'money', _vm.configMoney, false))], 1)], 1), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "DF"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    model: {
      value: _vm.form.aliquota.df,
      callback: function callback($$v) {
        _vm.$set(_vm.form.aliquota, "df", $$v);
      },
      expression: "form.aliquota.df"
    }
  }, 'money', _vm.configMoney, false))], 1)], 1), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "ES"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    model: {
      value: _vm.form.aliquota.es,
      callback: function callback($$v) {
        _vm.$set(_vm.form.aliquota, "es", $$v);
      },
      expression: "form.aliquota.es"
    }
  }, 'money', _vm.configMoney, false))], 1)], 1), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "GO"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    model: {
      value: _vm.form.aliquota.go,
      callback: function callback($$v) {
        _vm.$set(_vm.form.aliquota, "go", $$v);
      },
      expression: "form.aliquota.go"
    }
  }, 'money', _vm.configMoney, false))], 1)], 1), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "MA"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    model: {
      value: _vm.form.aliquota.ma,
      callback: function callback($$v) {
        _vm.$set(_vm.form.aliquota, "ma", $$v);
      },
      expression: "form.aliquota.ma"
    }
  }, 'money', _vm.configMoney, false))], 1)], 1), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "MG"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    model: {
      value: _vm.form.aliquota.mg,
      callback: function callback($$v) {
        _vm.$set(_vm.form.aliquota, "mg", $$v);
      },
      expression: "form.aliquota.mg"
    }
  }, 'money', _vm.configMoney, false))], 1)], 1), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "MS"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    model: {
      value: _vm.form.aliquota.ms,
      callback: function callback($$v) {
        _vm.$set(_vm.form.aliquota, "ms", $$v);
      },
      expression: "form.aliquota.ms"
    }
  }, 'money', _vm.configMoney, false))], 1)], 1), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "MT"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    model: {
      value: _vm.form.aliquota.mt,
      callback: function callback($$v) {
        _vm.$set(_vm.form.aliquota, "mt", $$v);
      },
      expression: "form.aliquota.mt"
    }
  }, 'money', _vm.configMoney, false))], 1)], 1), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "PA"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    model: {
      value: _vm.form.aliquota.pa,
      callback: function callback($$v) {
        _vm.$set(_vm.form.aliquota, "pa", $$v);
      },
      expression: "form.aliquota.pa"
    }
  }, 'money', _vm.configMoney, false))], 1)], 1), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "PB"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    model: {
      value: _vm.form.aliquota.pb,
      callback: function callback($$v) {
        _vm.$set(_vm.form.aliquota, "pb", $$v);
      },
      expression: "form.aliquota.pb"
    }
  }, 'money', _vm.configMoney, false))], 1)], 1), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "PE"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    model: {
      value: _vm.form.aliquota.pe,
      callback: function callback($$v) {
        _vm.$set(_vm.form.aliquota, "pe", $$v);
      },
      expression: "form.aliquota.pe"
    }
  }, 'money', _vm.configMoney, false))], 1)], 1), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "PI"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    model: {
      value: _vm.form.aliquota.pi,
      callback: function callback($$v) {
        _vm.$set(_vm.form.aliquota, "pi", $$v);
      },
      expression: "form.aliquota.pi"
    }
  }, 'money', _vm.configMoney, false))], 1)], 1), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "PR"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    model: {
      value: _vm.form.aliquota.pr,
      callback: function callback($$v) {
        _vm.$set(_vm.form.aliquota, "pr", $$v);
      },
      expression: "form.aliquota.pr"
    }
  }, 'money', _vm.configMoney, false))], 1)], 1), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "RJ"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    model: {
      value: _vm.form.aliquota.rj,
      callback: function callback($$v) {
        _vm.$set(_vm.form.aliquota, "rj", $$v);
      },
      expression: "form.aliquota.rj"
    }
  }, 'money', _vm.configMoney, false))], 1)], 1), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "RN"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    model: {
      value: _vm.form.aliquota.rn,
      callback: function callback($$v) {
        _vm.$set(_vm.form.aliquota, "rn", $$v);
      },
      expression: "form.aliquota.rn"
    }
  }, 'money', _vm.configMoney, false))], 1)], 1), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "RO"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    model: {
      value: _vm.form.aliquota.ro,
      callback: function callback($$v) {
        _vm.$set(_vm.form.aliquota, "ro", $$v);
      },
      expression: "form.aliquota.ro"
    }
  }, 'money', _vm.configMoney, false))], 1)], 1), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "RR"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    model: {
      value: _vm.form.aliquota.rr,
      callback: function callback($$v) {
        _vm.$set(_vm.form.aliquota, "rr", $$v);
      },
      expression: "form.aliquota.rr"
    }
  }, 'money', _vm.configMoney, false))], 1)], 1), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "RS"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    model: {
      value: _vm.form.aliquota.rs,
      callback: function callback($$v) {
        _vm.$set(_vm.form.aliquota, "rs", $$v);
      },
      expression: "form.aliquota.rs"
    }
  }, 'money', _vm.configMoney, false))], 1)], 1), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "SC"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    model: {
      value: _vm.form.aliquota.sc,
      callback: function callback($$v) {
        _vm.$set(_vm.form.aliquota, "sc", $$v);
      },
      expression: "form.aliquota.sc"
    }
  }, 'money', _vm.configMoney, false))], 1)], 1), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "SE"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    model: {
      value: _vm.form.aliquota.se,
      callback: function callback($$v) {
        _vm.$set(_vm.form.aliquota, "se", $$v);
      },
      expression: "form.aliquota.se"
    }
  }, 'money', _vm.configMoney, false))], 1)], 1), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "SP"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    model: {
      value: _vm.form.aliquota.sp,
      callback: function callback($$v) {
        _vm.$set(_vm.form.aliquota, "sp", $$v);
      },
      expression: "form.aliquota.sp"
    }
  }, 'money', _vm.configMoney, false))], 1)], 1), _c('b-col', {
    attrs: {
      "md": "2"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "TO"
    }
  }, [_c('money', _vm._b({
    staticClass: "form-control",
    model: {
      value: _vm.form.aliquota.to,
      callback: function callback($$v) {
        _vm.$set(_vm.form.aliquota, "to", $$v);
      },
      expression: "form.aliquota.to"
    }
  }, 'money', _vm.configMoney, false))], 1)], 1)], 1)], 1)], 1)], 1), _c('div', {
    staticClass: "card-footer"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('button', {
    ref: "submit_nova_tributacao",
    staticClass: "btn btn-primary font-weight-bold",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v(" Salvar ")]), _c('router-link', {
    staticClass: "btn btn-clean font-weight-bold",
    attrs: {
      "to": {
        name: 'tributacoesLista'
      }
    }
  }, [_vm._v(" Cancelar ")])], 1)])])])], 1)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };